import { getEnvironmentVariable } from "./global/environmentVariables";

export const scope = (clientId) => {
  let _scope = [];
  let _scopeDictVariable = getEnvironmentVariable("SCOPE_DICT");
  if (clientId && _scopeDictVariable !== undefined) {
    try {
      let _scopeDict = JSON.parse(_scopeDictVariable);
      if (_scopeDict[clientId]) {
        _scope = _scopeDict[clientId];
        return _scope;
      }
    } catch (err) {}
  }
  let _scopeVariable = getEnvironmentVariable("SCOPE");
  if (_scopeVariable !== undefined) {
    try {
      _scope = JSON.parse(_scopeVariable);
    } catch (err) {}
  }

  return _scope;
};
